"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var dropdown_button_1 = require("../dropdown-button");
var avatar_1 = require("../avatar");
var MastheadUserMenu = /** @class */ (function (_super) {
    __extends(MastheadUserMenu, _super);
    function MastheadUserMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MastheadUserMenu.prototype.render = function () {
        var _a = this.props, className = _a.className, greeting = _a.greeting, userInitials = _a.userInitials, userImageUrl = _a.userImageUrl, textField = _a.textField, reversed = _a.reversed;
        var dropdownButtonProps = _1.pick(this.props, Object.keys(dropdown_button_1.DropdownButton.propTypes));
        var customProps = _1.omit(this.props, Object.keys(MastheadUserMenu.propTypes));
        var rootClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('masthead-user-menu')] = true,
            _b);
        var display = [
            React.createElement(avatar_1.Avatar, { key: "avatar", size: "sm", initials: userInitials, url: userImageUrl }),
            React.createElement("span", { key: "greeting", className: vdl_prefix_1.vdlPrefix('masthead-user-menu__greeting') }, greeting)
        ];
        if (reversed) {
            display.reverse();
        }
        return (React.createElement(dropdown_button_1.DropdownButton, __assign({}, customProps, dropdownButtonProps, { buttonStyle: "link", textField: textField, className: classnames_1.classNames(className, rootClasses) }), display));
        var _b;
    };
    MastheadUserMenu.propTypes = Object.assign({}, dropdown_button_1.DropdownButton.propTypes, {
        greeting: PropTypes.string,
        userInitials: PropTypes.string,
        userImageUrl: PropTypes.string
    });
    MastheadUserMenu.defaultProps = {
        textField: 'label'
    };
    return MastheadUserMenu;
}(React.Component));
exports.MastheadUserMenu = MastheadUserMenu;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/masthead/masthead-user-menu.js
// module id = 556
// module chunks = 0 1 2 3 4 5 6